module.exports = __webpack_public_path__ + "static/mgmt-consulting-dad378d79f68804be3667455783f23c8.svg";